import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" {...this.props}><path fill="none" stroke="#636768" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M15.797 6.333a13.818 13.818 0 0 1 2.448-.217c7.593 0 13.746 6.154 13.746 13.745 0 7.593-6.152 13.747-13.745 13.747-7.59 0-13.745-6.154-13.745-13.746 0-2.597.72-5.027 1.974-7.1" /><path fill="#EBEEEF" stroke="#636768" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M14.977 6.306l6.538-4.664-.098 2.507-.207 5.33-.103 2.637-6.13-5.81" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/assets/icons/rotate-ccw.svg